import './styles.scss';
import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@edx/paragon';
import { ArrowRightAlt } from '@edx/paragon/icons';
import { FormattedMessage } from 'gatsby-plugin-react-intl';

import ProspectusLink from '@prospectus/common/ui-strict/ProspectusLink';

// Sort topics alphabetically by the topic name
const getSortedTopics = (topics) => topics.sort((a, b) => {
  const nameA = a.relatedTopic.topicString;
  const nameB = b.relatedTopic.topicString;
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }

  return 0;
});

function TopicRouting({
  relatedTopics,
  relatedSubjects,
  title,
}) {
  const sortedTopics = getSortedTopics(relatedTopics);

  return (
    <div className="topic-routing">
      <div className="container mw-lg routing-container px-sm-0">
        <nav className="related-links">
          <div className="row no-gutters">
            <div className="col-12">
              <h2 className="h2 topic-section-title">{title}</h2>
            </div>
          </div>
          <ol className="related-topics-list list-inline">
            {sortedTopics.map(({ relatedTopic }) => (
              <li className="topic-item mr-4" key={relatedTopic.topicString}>
                <ProspectusLink
                  href={`${relatedTopic.topicUrl}`}
                  className="d-flex align-items-center"
                  analytics={{
                    eventName: 'edx.bi.link.subject-routing.clicked',
                    linkProps: {
                      location: 'routing',
                      topic: relatedTopic,
                    },
                  }}
                >
                  {relatedTopic.topicString}
                  <Icon src={ArrowRightAlt} className="d-inline-block pgn__icon__lg ml-3" />
                </ProspectusLink>
              </li>
            ))}
          </ol>
          {relatedSubjects.length > 0
              && (
              <div className="js-related-subjects">
                <div className="row">
                  <div className="col-12">
                    <h3 className="h3 section-subtitle">
                      <FormattedMessage
                        id="topic.routing.browse.title"
                        defaultMessage="Browse subjects"
                        description="Title for browsing subjects section."
                      />
                    </h3>
                  </div>
                </div>
                <ol className="related-subjects-list list-inline">
                  {relatedSubjects.map(({ relatedSubject }) => (
                    <li className="subject-item px-0" key={relatedSubject.subjectString}>
                      <ProspectusLink
                        href={relatedSubject.subjectUrl}
                        className="subject-btn btn"
                        analytics={{
                          eventName: 'edx.bi.link.subject-routing.clicked',
                          linkProps: {
                            location: 'routing',
                            relatedSubject,
                          },
                        }}
                      >
                        {relatedSubject.subjectString}
                      </ProspectusLink>
                    </li>
                  ))}
                </ol>
              </div>
              )}
        </nav>
      </div>
    </div>
  );
}

TopicRouting.propTypes = {
  relatedTopics: PropTypes.arrayOf(PropTypes.shape({
    relatedTopic: PropTypes.shape({
      topicString: PropTypes.string,
      topicUrl: PropTypes.string,
    }),
  })).isRequired,
  relatedSubjects: PropTypes.arrayOf(PropTypes.shape({
    relatedSubject: PropTypes.shape({
      subjectString: PropTypes.string,
      subjectUrl: PropTypes.string,
    }),
  })),
  title: PropTypes.string.isRequired,
};

TopicRouting.defaultProps = {
  relatedSubjects: [],
};

export default TopicRouting;
